import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import Helper from "util/Helper";

/**
 * Sleep + step tracker client. Only the daily-steps read is exposed
 * here — that's all the patient dashboard needs today. Sleep + targets
 * live on the same service but are unused by phr-frontend.
 *
 * Endpoint: `GET /api/v1/sleep-step-tracker/steps/{pid}?from={iso}&to={iso}`.
 * Response (verified against bridge-frontend usage):
 *   { patientId, steps: { [dayISO]: count }, average, streak }
 * The `steps` map's keys are UTC-midnight day timestamps as ISO strings.
 * Days with no synced data don't appear in the map at all — a device
 * that hasn't synced for weeks returns `{ steps: {}, average: 0 }`.
 */
class StepTrackerService {
  constructor() {
    this.apiService = new APIService();
    // Side effect: installs String.prototype.format for the URL templates.
    this.helper = new Helper();
  }

  /**
   * Steps in a date window. Both bounds MUST be RFC3339 ISO with a
   * trailing Z (the backend's `time.Parse` layout is
   * `2006-01-02T15:04:05.000Z`); `new Date().toISOString()` yields
   * exactly that shape.
   */
  getSteps(patientId, fromISO, toISO, onResponse, onError) {
    const url = APIConfig.stepTracker.getSteps.format(
      patientId,
      encodeURIComponent(fromISO),
      encodeURIComponent(toISO),
    );
    return this.apiService.get(url, onResponse, onError);
  }
}

export default StepTrackerService;
